<template>
  <div class="multi-select" @click="showPopup">
    <span
      class="multi-select-textarea"
      v-if="showValue"
    >{{showValue}}</span>
    <span
      class="placeholder"
      v-else
    >{{ gettext('请选择') }}</span>
    <!-- <rich-textarea
      class="multi-select-textarea"
      :placeholder="gettext('请选择')"
      :value="showValue"
    ></rich-textarea> -->
  </div>
</template>

<script type="text/ecmascript-6">
import { i18n } from '@/common/utils/i18n'

export default {
  name: 'MultiSelectNew',
  components: {
  },
  props: {
    value: {
      required: true,
      type: Array,
      default: () => []
    },
    title: {
      required: false,
      type: String,
      default: i18n.gettext('请选择')
    },
    placeholder: {
      required: false,
      type: String,
      default: i18n.gettext('请选择')
    },
    options: {
      required: true,
      type: Array,
      default: () => []
    },
    fullScreen: {
      required: false,
      type: Boolean,
      default: true
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    zIndex: {
      required: false,
      type: Number,
      default: 101
    }
  },
  computed: {
    // selectedValue () {
    //   const res = []
    //   for (let i = 0; i < this.selectedTags.length; i++) {
    //     res.push(i)
    //   }
    //   return res
    // },
    // selectedTags () {
    //   return this.tagData.filter(tag => this.value.includes(tag.id))
    // },
    // tagData () {
    //   return this.options.length
    //     ? this.options.map(option => ({ name: option.label, id: option.value }))
    //     : []
    // }
    showValue () {
      const selected = this.options.filter(option => {
        return this.value.includes(option.value)
      })
      return selected.length ? selected.map(i => i.label).join('; ') : ''
    }
  },
  methods: {
    showPopup () {
      if (this.disabled) {
        return
      }
      this.$createMultiSelectPicker({
        $props: {
          fullScreen: this.fullScreen,
          zIndex: this.zIndex,
          value: this.value,
          options: this.options,
          title: this.title
        },
        $events: {
          select: (data) => {
            this.$emit('input', data)
          }
        }
      }).show()
    }
  }
}
</script>

<style lang="scss" scoped>
.multi-select {
  overflow: auto;
  min-height: 64px;
  text-align: left;
  &-textarea {
    background-color: #FFFFFF;

    ::v-deep .rich-textarea-label-placeholder {
      display: none;
    }

    ::v-deep textarea {
      line-height: 28Px;
    }
  }
  .placeholder{
    font-size: 18Px;
    color: #999;
    text-overflow: ellipsis;
    font-weight: 300;
    text-align: left;
    font-family: DiDiSans-Pro-Thin,DiDiSansPro-Thin,DiDiSans Pro Thin,Aspira Light;
  }
}
</style>
